/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { loadingAboutMeConfig } from '../../config/loading.config';
export interface ILoadingAboutMePluginMethods extends IPluginMethodMap {
  getLoadingAboutMeSync(args?: any): any;
}

export class LoadingAboutMePlugin implements IAgentPlugin {
  readonly methods: ILoadingAboutMePluginMethods;

  constructor() {
    this.methods = {
      getLoadingAboutMeSync: this.getLoadingAboutMeSync.bind(this),
    };
  }

  getLoadingAboutMeSync(args?: any) {
    return {
      loading: loadingAboutMeConfig,
    };
  }
}
